module.exports = __webpack_public_path__ + "static/media/redhatexs.ef629f12.png";